__turbopack_context__.v({
  "className": "saansmono_7f27222-module__I62Zqa__className",
  "variable": "saansmono_7f27222-module__I62Zqa__variable",
});
